import OrganizationEmail from "./OrganizationEmail"

export default OrganizationEmail
